module.exports = __webpack_public_path__ + "img/sb00.1847f1d7.png";